<template>
  <div class="source-dialog-form">
    <md-progress
      v-if="loading"
      md-indeterminate
    ></md-progress>
    <source-dialog-header
      v-if="dialogMode"
      :value="value"
      :disabled="loading"
      @load-article="getElibraryArticle"
      @load-digital-resource="getDigitalResource"
      @input="$emit('input', arguments[0])"
    ></source-dialog-header>
    <source-dialog-expanded-header
      v-else
      :value="value"
      :disabled="loading"
      @load-article="getElibraryArticle"
      @load-digital-resource="getDigitalResource"
      @toggle-custom="onToggleCustom"
    ></source-dialog-expanded-header>

    <source-dialog-custom
      :class="{'custom-toggable': !dialogMode, 'hidden': !showCustom}"
      :value="value"
      :disabled="loading"
      @input="$emit('input', arguments[0])"
    ></source-dialog-custom>
  </div>
</template>

<script>
import { getDefaultSourceData } from '@/shared/defaults.js'
import elibraryParser from 'elib-parser'
import getPageInfo from '@/shared/pageinfo.js'
import SourceDialogCustom from './SourceDialogCustom.vue'
import SourceDialogHeader from './SourceDialogHeader.vue'
import SourceDialogExpandedHeader from './SourceDialogExpandedHeader.vue'
import superagent from 'superagent'
export default {
  name: 'SourceDialogForm',

  components: {
    SourceDialogCustom,
    SourceDialogHeader,
    SourceDialogExpandedHeader
  },

  props: {
    value: Object,
    dialogMode: {
      type: Boolean,
      default: true
    }
  },

  data () {
    return {
      showCustom: this.dialogMode ? true : false,
      loading: false,
      link: ''
    }
  },

  methods: {
    setValue (field, value) {
      this.$emit('input', {...this.value, [field]: value})
    },
    getElibraryArticle (id) {
      this.loading = true
      const url = `https://elibrary.ru/item.asp?id=${id}`
      superagent.get('/elibrary/start_session.asp').query({ rpage: url }).then(() => {
        return elibraryParser({'url': '/elibrary'}).getArticle(id)
      }).then((sourceData) => {
        this.$emit(
          'input',
          {
            ...getDefaultSourceData(),
            ...sourceData,
            type: 'article',
            url
          }
        )
        this.loading = false
      }).catch((err) => {
        this.loading = false
        this.handleError(err)
      })
    },
    getDigitalResource (url) {
      this.loading = true
      getPageInfo(url).then((result) => {
        const values = {
          ...getDefaultSourceData(),
          type: 'resource',
          url,
          title: result.name,
          source: result.source
        }
        this.$emit('input', {...this.value, ...values})
        this.loading = false
      }).catch((err) => {
        this.handleError(err)
        this.loading = false
      })
    },
    onToggleCustom () {
      this.showCustom = !this.showCustom
    }
  }
}
</script>

<style lang="sass" scoped>
.source-dialog-custom
  transition-property: max-height
  transition-duration: .5s
  transition-timing-function: ease-in
  max-height: 1000px
  overflow-y: hidden
.hidden
  max-height: 0
</style>


// WEBPACK FOOTER //
// SourceDialogForm.vue?3e0a84db